import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { IPolicyDocumentResponseDto } from '@core/interfaces/api/policies/policy-document-response-dto.interface';
import { GetPolicyUseCaseService } from './use-cases/get-policy.use-case.service';
import { DocumentTypeEnum } from '@core/enums/document/document-type.enum';
import { PolicyToPageMapperService } from './mappers/accept-policy.mapper.service';
import { map } from 'rxjs';

export const getPolicyResolver: ResolveFn<IPolicyDocumentResponseDto> = (
  route: ActivatedRouteSnapshot
) => {
  const getPolicyUseCase = inject(GetPolicyUseCaseService);
  const policyMapper = inject(PolicyToPageMapperService);

  const policyType = route.data['policyType'] as DocumentTypeEnum;

  return getPolicyUseCase
    .execute(policyType)
    .pipe(map(policy => policyMapper.mapTo({ ...policy, type: policyType })));
};
